import React from 'react';
import './landing.css';
import computer from './images/AntidoteToChurn.png';
import user from './images/12.png';
import AppearingElement from "../Helper/AppearingElement";
import { Typography, Grid } from "@material-ui/core";
import background from "../images/BACKGROUND2.svg";
import { Parallax } from 'react-scroll-parallax';

class ComputerSection extends React.Component {
    render() {
        return (
            <div className="computer-section">
                <div className="computer-section__container">
                    <Grid container spacing={0}>
                        <Grid className="computer-section__image-container" item sm={12} md={8}>

                            <img src={computer} alt="" className="computer-section__computer" />
                            <div className="computer-section__user" >
                                <Parallax x={[-60, -10]}>
                                    <img src={user} alt="" className="computer-section__user-image" />
                                </Parallax>
                            </div>

                        </Grid>

                        <Grid item xs={12} sm={12} md={4} >

                            <div className="computer-section__main-text">
                                <AppearingElement variant={'zoom-up'}>
                                    <Typography variant="h3">{this.props.title}</Typography>
                                </AppearingElement>
                            </div>
                            <div className="computer-section__sub-text">
                                <AppearingElement variant={'zoom-up'}>
                                    <Typography variant="h5" >{this.props.subtitle}</Typography>
                                </AppearingElement>
                            </div>

                        </Grid>
                    </Grid>
                </div>
                <img src={background} alt="" className="computer-section__background" />
            </div>
        )
    }
}

export default ComputerSection;